import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@sea-snag/ui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$orgPid/messaging')({
  component: MessagingPage,
});

function MessagingPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Inbox</h1>
        <p className="text-muted-foreground">
          All client conversations in one place — WhatsApp, MMK, and NauSYS
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        <Card>
          <CardHeader>
            <CardTitle>WhatsApp</CardTitle>
            <CardDescription>Messages from WhatsApp Business</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground text-sm">
              Connect your WhatsApp Business account in Integrations to start receiving messages.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>MMK</CardTitle>
            <CardDescription>Booking Manager inquiries</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground text-sm">
              Inquiries from your MMK integration will appear here automatically.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>NauSYS</CardTitle>
            <CardDescription>NauSYS messages</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground text-sm">
              Messages from your NauSYS integration will appear here automatically.
            </p>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>All Conversations</CardTitle>
          <CardDescription>
            Unified thread view across all channels. Reply to clients from any channel without
            switching apps.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground text-sm">
            No conversations yet. Connect an integration to start receiving messages.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
